module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_icons/icn-ir-stock-0859671d8a6ac5eba509af0993d1de4b.svg";